/**
 * The card's category glyph — `bimgo-ai-web`'s `skillCategory.ts` verbatim:
 * three keyword families over the name and description, and a default. The
 * labels are the reference's (Chinese in both locales there; they are i18n
 * keys here so `en` gets words too).
 */
export type SkillCategoryId = "mep" | "structure" | "revit-ops" | "default";

export interface SkillCategory {
  id: SkillCategoryId;
  labelKey: string;
}

const CATEGORY_MAP: (SkillCategory & { pattern: RegExp })[] = [
  {
    id: "mep",
    pattern: /pipe|duct|conduit|mep|hvac|mechanical|electrical|plumbing|sprinkler|管道|風管|電氣|機械|消防|給排水|設備/i,
    labelKey: "skills.category.mep",
  },
  {
    id: "structure",
    pattern: /beam|column|foundation|structural|rebar|slab|truss|梁|柱|基礎|結構|鋼筋|板|桁架/i,
    labelKey: "skills.category.structure",
  },
  {
    id: "revit-ops",
    pattern:
      /view|sheet|schedule|family|parameter|level|grid|tag|room|annotation|link|export|import|print|圖紙|明細表|族群|參數|樓層|軸線|標注|視圖|房間|匯出|匯入|列印/i,
    labelKey: "skills.category.revitOps",
  },
];

const DEFAULT_CATEGORY: SkillCategory = { id: "default", labelKey: "skills.category.default" };

export function getSkillCategory(skill: { name: string; description?: string | null }): SkillCategory {
  const text = `${skill.name} ${skill.description ?? ""}`;
  for (const { pattern, id, labelKey } of CATEGORY_MAP) {
    if (pattern.test(text)) return { id, labelKey };
  }
  return DEFAULT_CATEGORY;
}
